// extracted by mini-css-extract-plugin
export default {"label":"CandyMachineSaleDate_label__turiV"};